<template>
  <div class="mx-4 mt-3 mb-1">
    <div class="border-t border-gray-100"></div>
    <button
      v-if="!collapsed && toggleable"
      type="button"
      class="section-header-button"
      :class="{ 'section-header-button--active': active }"
      @click="$emit('toggle')"
    >
      <span class="w-1.5 h-1.5 rounded-full flex-shrink-0" :style="{ backgroundColor: color }"></span>
      <span class="text-[11px] font-bold tracking-wide flex-1 text-left" :style="{ color }">{{ title }}</span>
      <el-icon class="text-[12px] text-gray-400 transition-transform duration-200" :class="{ 'rotate-180': expanded }">
        <ArrowDown />
      </el-icon>
    </button>
    <div v-else-if="!collapsed" class="flex items-center gap-2 pt-3 pb-1 px-2">
      <span class="w-1.5 h-1.5 rounded-full flex-shrink-0" :style="{ backgroundColor: color }"></span>
      <span class="text-[11px] font-bold tracking-wide" :style="{ color }">{{ title }}</span>
    </div>
    <div v-else class="pt-2"></div>
  </div>
</template>

<script setup lang="ts">
import { ArrowDown } from '@element-plus/icons-vue'

withDefaults(defineProps<{
  title: string
  color: string
  collapsed: boolean
  toggleable?: boolean
  expanded?: boolean
  active?: boolean
}>(), {
  toggleable: false,
  expanded: true,
  active: false
})

defineEmits<{ toggle: [] }>()
</script>

<style scoped>
.section-header-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.75rem 0.5rem 0.25rem;
  border-radius: 0.625rem;
  transition: background-color 0.2s ease;
}

.section-header-button:hover {
  background: #f9fafb;
}

.section-header-button--active {
  background: #f8fafc;
}
</style>
